import { render, staticRenderFns } from "./otherDetail.vue?vue&type=template&id=3dfa2b2e&scoped=true&"
import script from "./otherDetail.vue?vue&type=script&lang=js&"
export * from "./otherDetail.vue?vue&type=script&lang=js&"
import style0 from "./otherDetail.vue?vue&type=style&index=0&id=3dfa2b2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfa2b2e",
  null
  
)

export default component.exports